var $name="sortDirections",$path="configs/sortDirections.js",$this={$name,$path,};module.exports = {
  asc: 'asc',
  desc: 'desc',
};
